export default "__VITE_ASSET__DysxXNXW__"